$('.js-has-dropdown').each(function() {
    const dropdown = $(this).find('.js-dropdown');

    $(this).click(function(evt) {
        evt.preventDefault();
        if (!(dropdown[0].contains(evt.currentTarget))) {
            dropdown.toggleClass('open');
            evt.stopPropagation();
        }
    });

    $(document).on('click', function(evt) {
        if (!dropdown[0].contains(evt.target) && dropdown.is('.open')) {
            dropdown.removeClass('open');
        }
    });

    $(document).on('keyup', function(evt) {
        if (evt.key == 'Escape' && dropdown.is('.open')) {
            dropdown.removeClass('open');
        }
    });
});
